"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_mail_feature_flags_1 = require("owa-mail-feature-flags");
var getUserConfiguration_1 = require("owa-session-store/lib/actions/getUserConfiguration");
var folderIdToName_1 = require("owa-session-store/lib/utils/folderIdToName");
var folderNameToId_1 = require("owa-session-store/lib/utils/folderNameToId");
// Same order as in OWA:MailFolderTreeNodeViewModel.cs
var FOLDERS_TO_SHOW_FIRST = [
    'inbox',
    'junkemail',
    'drafts',
    'sentitems',
    'deleteditems',
];
var GEEK_FOLDERS_TO_HIDE = ['journal', 'outbox', 'syncissues'];
var FOLDER_DELIMITER = '\\';
// returns the flat folder tree to be used in the move to dropdown
function getMoveToDropdownFolders(folderMap, root) {
    // Get flat folder tree
    var dropdownFolderList = [];
    // First get the first level of the tree in order, with special folders first
    var childFolderIds = getFirstLevelFoldersInOrder(root, folderMap);
    // recursively add all of the child folders of the root
    addAllChildFolders(dropdownFolderList, childFolderIds, folderMap, '');
    return dropdownFolderList;
}
exports.default = getMoveToDropdownFolders;
function getFirstLevelFoldersInOrder(root, folderMap) {
    var childFolderIds = [];
    // First add all the special folders.
    FOLDERS_TO_SHOW_FIRST.forEach(function (distinguishedFolderId) {
        var folder = folderMap.get(folderNameToId_1.default(distinguishedFolderId));
        if (folder && shouldDisplayFolderInFolderTree(folder)) {
            childFolderIds.push(folder.folderId);
        }
    });
    // Add all the remaining folders that are not part of the special list above.
    if (root && root.childFolderIds) {
        root.childFolderIds.map(function (childId) {
            var folder = folderMap.get(childId);
            if (folder &&
                FOLDERS_TO_SHOW_FIRST.indexOf(folderIdToName_1.default(folder.folderId)) == -1 &&
                shouldDisplayFolderInFolderTree(folder)) {
                childFolderIds.push(folder.folderId);
            }
        });
    }
    return childFolderIds;
}
// Recursive function to add all child folders in tree for dropdown list
function addAllChildFolders(dropdownFolderList, childFolders, folderMap, currentPath) {
    for (var _i = 0, childFolders_1 = childFolders; _i < childFolders_1.length; _i++) {
        var childFolderId = childFolders_1[_i];
        var childFolder = folderMap.get(childFolderId);
        // Don't add hidden folders or special folders(they are already added) to list
        if (shouldDisplayFolderInFolderTree(childFolder)) {
            var childFolderPath = currentPath + childFolder.displayName;
            childFolder.path = childFolderPath;
            dropdownFolderList.push(childFolder);
            if (childFolder.childFolderIds) {
                addAllChildFolders(dropdownFolderList, childFolder.childFolderIds, folderMap, childFolderPath + FOLDER_DELIMITER);
            }
        }
    }
}
function isOfTypeMailFolder(folder) {
    return folder && folder.folderType == 'Folder:#Exchange';
}
function shouldDisplayFolderInFolderTree(folder) {
    // Do not show the folder if it's not a mail folder.
    if (!isOfTypeMailFolder(folder)) {
        return false;
    }
    // Suppress hidden and 'geek' folders (outbox, journal, etc).
    if (folder.isHidden || GEEK_FOLDERS_TO_HIDE.indexOf(folderIdToName_1.default(folder.folderId)) >= 0) {
        return false;
    }
    // Only show the Notes folder if that feature is enabled.
    var userConfiguration = getUserConfiguration_1.default();
    if (folderIdToName_1.default(folder.folderId) == 'notes') {
        return (userConfiguration.SegmentationSettings.StickyNotes &&
            owa_mail_feature_flags_1.isMailFeatureEnabled('cal-stickyNotesFolder'));
    }
    // Only show the Junk Email folder if that feature is enabled.
    if (folderIdToName_1.default(folder.folderId) == 'junkemail' &&
        !userConfiguration.SegmentationSettings.JunkEMail) {
        return false;
    }
    // Good folder!
    return true;
}
//# sourceMappingURL=getMoveToDropdownFolders.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/helpers/getMoveToDropdownFolders.js
// module id = 5224
// module chunks = 2